import React from 'react';
import { IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIconButton from './WhatsAppIconButton';
import Flex from 'legacyfrontend/components/Flex';

const ContactIconsGroup = ({ 
  packageUrlWhatsapp = null,
  productName = null,
  productRefNumber = null,
  onEmailClick = null,
  emailButtonSx = {},
}) => {
  const defaultEmailSx = {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#1976d2',
    color: 'white',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#1565c0',
      transform: 'translateY(-2px)',
    },
    ...emailButtonSx,
  };

  return (
    <Flex className='card-box package-details__payment-card' vertical>
      <Flex className='package-details__payment-card__header with-bottom-divider'>
        <p style={{ fontWeight: 600 }}>Comunicate con nosotros</p>
      </Flex>
      <Flex className='package-details__payment-card__content' style={{ justifyContent: 'center', padding: '1rem 0' }}>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <IconButton
            onClick={onEmailClick}
            sx={defaultEmailSx}
            aria-label="Contactar por email"
            title="Enviar email"
          >
            <EmailIcon />
          </IconButton>
          <WhatsAppIconButton
            packageUrlWhatsapp={packageUrlWhatsapp}
            productName={productName}
            productRefNumber={productRefNumber}
          />
        </div>
      </Flex>
    </Flex>
  );
};

export default ContactIconsGroup;
